import { useUniqueInlineId } from '@inline-svg-unique-id/react'
import React from 'react'
import { SVGIconProps } from '../types'
const SvgArcherClassPatrolBoat = function ({
  size = 16,
  ...props
}: SVGIconProps) {
  const _id = useUniqueInlineId()
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width={size}
      height={size}
      viewBox="0 0 200 66"
      fill="currentColor"
      {...props}
    >
      <defs>
        <path
          id={_id}
          d="m161.281 0-.001 1.358h2.443l-.812 2.05V23.44h-.767v1.577h.77l.16 4.732h5.335v11.04h-4.957l.23 6.723h9.61v-3.336l-.106-.01v-1.187c-2.138 0-3.89-1.684-3.89-3.766s1.752-3.767 3.89-3.767c2.158 0 3.89 1.685 3.89 3.767l-.008.25h12.746a4 4 0 0 1-.008-.25c0-2.082 1.732-3.767 3.89-3.767 2.138 0 3.88 1.685 3.88 3.767 0 1.998-1.605 3.63-3.626 3.758l-.26.008v1.186l-.103.011v3.336h5.232c.643 0 1.181.52 1.181 1.164s-.538 1.164-1.181 1.164h-.398l.002 15.707H23.836c-1.12-.623-2.225-1.93-3.268-2.75l-.28-.201q-3.198-2.22-8.225-6.968c-1.81-1.58-4.49-6.61-4.49-6.952l.007-.134-2.748 1.115 1.844 1.24c-2.728.066-6.302-.72-6.638-1.561-.184-.466.352-.662.536-.714l.06-.015H2.65l-.018-1.192c-.028-.21-.015-.7.71-.7l14.41.179.045.618h23.609l.247-1.268-1.367-2.22 5.224-3.226 1.902 3.076-2.93 1.8h1.562l.286 1.838h7.694l.248-1.266-1.363-2.221 5.223-3.227 1.893 3.076-2.93 1.8h1.558l.292 1.838h21.18l.001-5.947 11.019-9.534.025-.001-3.158-11.515 25.062-4.961h36.45l.002-.313 4.559-13.339h-1.61V.814h4.223L156.7 0zm26.202 44.833-4.083.44-4.013-.436v2.675h8.096z"
        />
      </defs>
      <use xlinkHref={`#${_id}`} fill="#3E5667" fillRule="evenodd" />
    </svg>
  )
}
export default SvgArcherClassPatrolBoat
